import { useEffect, useRef } from 'react';
import { pusher } from '../../hooks/pusher';

/**
 * Runs `onChanged` whenever the organisation's print templates change
 * (publish, archive, brand kit) — the server's `template-library-updated` on
 * `organisation-{id}`. Only unbinds on cleanup: the channel is shared.
 */
export const useTemplateLibraryEvents = ({ organisationId, onChanged }: { organisationId: string | null | undefined; onChanged: () => void }) => {
  const callbackRef = useRef(onChanged);
  useEffect(() => {
    callbackRef.current = onChanged;
  }, [onChanged]);

  useEffect(() => {
    if (!organisationId) return;
    const channel = pusher.subscribe(`organisation-${organisationId}`);
    const handler = () => callbackRef.current();
    channel.bind('template-library-updated', handler);
    return () => {
      channel.unbind('template-library-updated', handler);
    };
  }, [organisationId]);
};
